
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.28998 14.29L8.99998 17V21C8.99998 21.55 9.44998 22 9.99998 22H14C14.55 22 15 21.55 15 21V17L17.71 14.29C17.9 14.1 18 13.85 18 13.58V10C18 9.45 17.55 9 17 9H6.99998C6.44998 9 5.99998 9.45 5.99998 10V13.59C5.99998 13.85 6.10998 14.11 6.28998 14.29ZM12 2C12.55 2 13 2.45 13 3V4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4V3C11 2.45 11.45 2 12 2ZM4.20998 5.17C4.59998 4.78 5.22998 4.78 5.62998 5.17L6.33998 5.88C6.72998 6.27 6.72998 6.9 6.33998 7.29C5.94998 7.68 5.31998 7.68 4.92998 7.29L4.20998 6.58C3.81998 6.19 3.81998 5.56 4.20998 5.17ZM17.67 5.88L18.38 5.17C18.77 4.78 19.4 4.78 19.79 5.17C20.18 5.56 20.18 6.19 19.79 6.58L19.08 7.29C18.69 7.68 18.06 7.68 17.67 7.29C17.28 6.9 17.28 6.27 17.67 5.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-highlight`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHighlight

    ```js
    <b-new-b-icon-highlight />
    ```
</docs>


